<div class="row" *ngIf="recursos">
    <div class="col-sm-12" *ngIf="recursos && recursos.length > 0">
        <div class="table-responsive" class="tabela-resultados">
            <table suiteRfbTable>
                <thead>
                    <tr>
                        <th class="text-center">Tipo</th>
                        <th class="text-center">
                            Nome do LUD
                            <input type="text" class="filtro" [(ngModel)]="filtroNomeLUD" (ngModelChange)="filtrarLUD()">
                        </th>
                        <th class="text-center">Dispositivos <input type="text" class="filtro" [(ngModel)]="filtroDispositivo"></th>
                        <th class="text-center">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let r of recursosFiltrados | currentPage:(tipoPesquisa === 3 ? currentPage : { first: 0, last: recursosFiltrados.length, number: 1 })">
                        <td class="text-center">
                            <img src="/favicon-normas.ico" *ngIf="r.idAto">
                            <em class="material-icons icon-18" *ngIf="!r.idAto">language</em>
                        </td>
                        <td>{{ r.identificador }}</td>
                        <td>
                            <div>
                                <div class="badge-pair" *ngFor="let f of filtrar(r.fragmentos)">
                                    <span class="badge">
                                        {{ f.dispositivo }}
                                    </span>
                                    <em class="material-icons icon-24 btn-selecionar-dispositivo"
                                        (click)="clickSelecionarDispositivo(r,f)"
                                        title="Selecionar este dispositivo">arrow_circle_up</em>
                                </div>
                            </div>
                        </td>
                        <td class="text-center icones-edicao-recurso">
                            <em class="material-icons icon-18 icon-edicao-recurso" *ngIf="r.idRecurso" (click)="clickSelecionarRecurso(r)" title="Editar no banco de LUDs">edit</em>
                            <em class="material-icons icon-18 icon-edicao-recurso" *ngIf="!r.idRecurso" (click)="clickSelecionarRecurso(r)" title="Incluir no banco de LUDs">save_as</em>
                            <suite-rfb-confirmation-link popupTitle="Excluir do banco de LUDs" (accept)="excluirRecurso(r)"
                                    question="O recurso será excluído! Confirma a operação?" *ngIf="isGerirRecursos && r.idRecurso && tipoPesquisa === 3">
                                <em class="material-icons icon-18 icon-edicao-recurso" title="Excluir do banco de LUDs">delete</em>
                            </suite-rfb-confirmation-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="tabela-links" *ngIf="tipoPesquisa === 3">
            <suite-rfb-pagination [(itemAmount)]="recursosFiltrados.length" [(pageSize)]="pageSize" [(page)]="currentPage">
            </suite-rfb-pagination>
        </div>
    </div>
</div>
